// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__t3jhY","header":"Layout_header__uekhm","body":"Layout_body__SAvlJ","footer":"Layout_footer__Geth3"};